import { FieldErrors } from 'react-hook-form/dist/types/errors';
import { FormElementProps } from 'components/common/form/index';
import { TFunction } from 'i18next';
import { Box } from '@mui/material';
import React from 'react';

export default function FormElementErrorMessage({
    errors,
    elementProps,
    t,
}: {
    errors: FieldErrors<any>;
    elementProps: FormElementProps;
    t: TFunction;
}) {
    return errors[elementProps.component.uid] ? (
        <Box className={'container-remove-indent'} sx={{ color: 'error.main', pt: 0.25 }}>
            {!(errors[elementProps!.component!.uid]!.message as string).match(/^[a-zA-Z0-9\_\-\:\.\,\]\}\[\{]$/)
                ? (errors[elementProps!.component!.uid]!.message as string).replaceAll(
                      '{{label}}',
                      t(elementProps.component?.props?.label ?? ''),
                  )
                : t(errors[elementProps!.component!.uid]!.message as string, {
                      label: t(elementProps.component?.props?.label ?? ''),
                  })}
        </Box>
    ) : null;
}
